export interface InvoiceAccount {
  document: string;
  isAssociated: "Ativo" | "Inativo";
  name: string;
  contractChannel: string;
  contractNumber: string;
}

export interface Tariff {
  id: number;
  identifier: string;
  dueDate: string;
}

export interface Invoice {
  id: number;
  dueDate: string;
  isPaymentRequired: boolean;
  servicesType: string[];
  status: InvoiceStatusEnum;
  amount: string;
  total: number;
  tariffs?: Tariff[];
}

export enum InvoiceStatusEnum {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  CANCELED = "CANCELED"
}

export enum InvoiceStatusLabel {
  OPEN = "Em aberto",
  CLOSED = "Fechada",
  CANCELED = "Cancelada"
}
